export const cardInventoryControl = {
	cardInfo: {
		stockist: "Almacenista:",
		editedIn: "Editado en:",
		status: "Estado:",
		statusTag: {
			approved: "Aprobado",
			open: "Abierto",
			in_review: "En revisión",
			reopened: "Recontar",
		},
	},
};
